import {Grid} from '@mui/material';
import React, {useCallback, useMemo, useState} from "react";
import {getBookedLocations} from "../../../../components/location/requests/location-requests";
import LocationCardList from "./LocationCardList";
import SpaceUsageLoader from "../../../../components/deprecatedUikit/SpaceUsageCard/SpaceUsageLoader";
import {getErrorMessage} from "../../../../util/NetworkErrorUtil";
import LocationBuyerBookedSortFilter from "./LocationBuyerBookedSortFilter";
import {formatBookedLocations} from "./data";
import Pagination from "../../../../components/deprecatedUikit/Pagination/Pagination";
import NoMatchingInvoicesFound from '../../../../components/NoMatchingInvoicesFound';
import {useSnackbar} from "../../../../context/snackbar-context";

const LoadingSkeleton = () => {
  return <Grid item container direction={'column'} gap={2}>
    {Array.from({length: 10}).map((_, index) => <SpaceUsageLoader key={index} />)}
  </Grid>;
};

const LocationsBuyerBooked = () => {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const {snackbarShowMessage} = useSnackbar();

  const formattedBookedLocations = useMemo(() => (formatBookedLocations(locations)), [locations]);

  const handleSortFilterChange = useCallback((query) => {
    setLoading(true);
    getBookedLocations(query, page, size)
      .then(response => {
        const { content, totalElements, totalPages, pageable } = response.body;
        const {pageNumber} = pageable || {pageNumber: 0};
        setLocations(content || []);
        setTotalElements(totalElements || 0);
        if (pageNumber + 1 > totalPages) {
          // If the page index is greater than the total pages,
          // This will refresh the data and show the last page of results
          setPage(totalPages > 0 ? totalPages - 1 : 0);
        }
      }).catch(error => {
        snackbarShowMessage(getErrorMessage(error), 'error');
        setPage(0);
        setSize(10);
      }).finally(() => setLoading(false));
  }, [page, size, snackbarShowMessage]);

  return <Grid item container>
    <LocationBuyerBookedSortFilter onChange={handleSortFilterChange} />
    { loading ? <LoadingSkeleton /> : formattedBookedLocations?.length ? <LocationCardList locations={formattedBookedLocations} /> : <NoMatchingInvoicesFound message='You have not made any bookings yet. Visit the search page to find space.'/>}
    <Grid item container justifyContent={'end'}>
      <Pagination
        page={page}
        count={totalElements}
        rowsPerPage={size}
        onPageChange={(_event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => setSize(parseInt(event.target.value, 10))}
        variant={'tablePagination'}
      />
    </Grid>
  </Grid>
};

export default LocationsBuyerBooked;
